import MenuItems from './MenuItems';
const Dropdown = ({ submenus, dropdown, depthLevel, handlehamburger, handleCategoryClick }) => {
  depthLevel = depthLevel + 1;
  const dropdownClass = depthLevel > 1 ? 'dropdown-submenu' : '';
  return (
    <ul
      className={`dropdown ${dropdownClass} ${dropdown ? 'show' : ''
        }`}
    >
      {submenus.map((submenu, index) => (
        <MenuItems
          handlehamburger={handlehamburger}
          items={submenu}
          key={index}
          depthLevel={depthLevel}
          handleCategoryClick={handleCategoryClick}
        />
      ))}
    </ul>
  );
};

export default Dropdown;
